import { getRequest, postRequest } from 'config/Axios/baseConfig';
import {
  conceptInstanceInterface,
  conceptDetailsInterface,
  msplansalesSummaryInterface,
  activeMarketForecastInterface,
  salesplansalesSummaryInterface,
  tmsViewDataInterface,
  salesPlanView,
  salesPlanStatusInterface,
  gfcPlanStatusInterface,
  notesInterface,
  tmsDataInterface,
  planningPeriodInterface,
  salesplanconceptInstanceInterface,
  conceptInformationInterfaceWithNdcInformation,
  tmsEditScreenDataInterface,
  salesplanEditInterface,
  salesPlanBulkEditDataInterface,
  msPlanDataGetInterface,
  msPlanBulkEditDataInterface,
  updateNoteResponse,
} from 'Interfaces/FDPInterfaces/tmsInterfaces';

export const tmsScreenServices = {
  getAllGSMSconcepts: (): Promise<conceptInstanceInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<conceptInstanceInterface[]>(
          `fdp/gsms_direct_active_concepts`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getConceptDetails, Err===', error);
        reject(error);
      }
    });
  },

  getAllGSMSConceptForSalesPlan: (): Promise<salesplanconceptInstanceInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } =
          await getRequest<salesplanconceptInstanceInterface[]>(`fdp/all_gsms_concepts`);
        resolve(data);
      } catch (error) {
        console.log('in services > getAllGSMSConceptForSalesPlan, Err===', error);
        reject(error);
      }
    });
  },

  getAllActiveGSMSConceptsWithNdcInformation: (): Promise<
    conceptInformationInterfaceWithNdcInformation[]
  > => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<conceptInformationInterfaceWithNdcInformation[]>(
          `fdp/all_gsms_concepts_with_ndc`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getAllActiveGSMSConceptsWithNdcInformation, Err===', error);
        reject(error);
      }
    });
  },

  getMSplanPlanningPeriods: (gfc: number): Promise<planningPeriodInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<planningPeriodInterface[]>(
          `fdp/get_tms_planning_periods/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getMSplanPlanningPeriods, Err===', error);
        reject(error);
      }
    });
  },

  getSalesplanPlanningPeriods: (gfc: number): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<string[]>(`fdp/get_salesplan_planning_period/${gfc}`);
        resolve(data);
      } catch (error) {
        console.log('in services > getSalesplanPlanningPeriods, Err===', error);
        reject(error);
      }
    });
  },

  getSalesPlanStatus: (planning_period: string, gfc: number): Promise<salesPlanStatusInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<salesPlanStatusInterface>(
          `fdp/get_sales_plan_status/${planning_period}/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getSalesPlanStatus, Err===', error);
        reject(error);
      }
    });
  },

  getSalesPlanProgress: (): Promise<{ percentage: number }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<{ percentage: number }>(`fdp/get_sales_plan_progress`);
        resolve(data);
      } catch (error) {
        console.log('in services > getSalesPlanProgress, Err===', error);
        reject(error);
      }
    });
  },

  getGfcBulkPlanList: (): Promise<gfcPlanStatusInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<gfcPlanStatusInterface>(`fdp/get_sales_plan_status_all`);
        resolve(data);
      } catch (error) {
        console.log('in services > getGfcBulkPlanList, Err===', error);
        reject(error);
      }
    });
  },

  getGFCNotes: (
    gfc: number,
    planning_type: string,
    signal: AbortController['signal'] | null = null
  ): Promise<notesInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<notesInterface[]>(
            `fdp/get_note/${gfc}/${planning_type}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<notesInterface[]>(
            `fdp/get_note/${gfc}/${planning_type}`
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getGFCNotes, Err===', error);
        reject(error);
      }
    });
  },

  saveGFCNote: (payload: {
    gfc: number;
    note: string;
    planning_type: string;
  }): Promise<notesInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{
          msg: string;
          data: notesInterface[];
        }>(`fdp/save_gfc_note`, payload);
        resolve(data.data);
      } catch (error) {
        console.log('in services > saveGFCNote, Err===', error);
        reject(error);
      }
    });
  },

  getTMSSalesSummary: (gfc: number): Promise<msplansalesSummaryInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<msplansalesSummaryInterface[]>(
          `fdp/get_market_sales_summary/${gfc}/Share`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getSalesSummary, Err===', error);
        reject(error);
      }
    });
  },

  getSalesPlanSalesSummary: (gfc: number): Promise<salesplansalesSummaryInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<salesplansalesSummaryInterface[]>(
          `fdp/get_market_sales_summary/${gfc}/Volume`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getSalesSummary, Err===', error);
        reject(error);
      }
    });
  },

  getSingleGSMSConcept: (gfc: number): Promise<conceptDetailsInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<conceptDetailsInterface>(
          `fdp/get_concept_details/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getSingleGSMSConcept, Err===', error);
        reject(error);
      }
    });
  },

  getTMSAdjustments: (PP: string, GFC: number): Promise<tmsViewDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<tmsViewDataInterface>(
          `fdp/get_tms_adjustments/${PP}/${GFC}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getConceptTMS: (
    GFC: number,
    Planning_period: string,
    signal: AbortController['signal'] | null = null
  ): Promise<tmsDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<tmsDataInterface>(
            `fdp/view_tms_details/${GFC}/${Planning_period}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<tmsDataInterface>(
            `fdp/view_tms_details/${GFC}/${Planning_period}`
          );
          resolve(data);
        }
      } catch (err) {
        return reject(err);
      }
    });
  },

  getTmsEditScreenData: (
    GFC: number,
    Planning_period: string,
    signal: AbortController['signal'] | null = null
  ): Promise<tmsEditScreenDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<tmsEditScreenDataInterface>(
            `fdp/tms_edit_details/${GFC}/${Planning_period}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<tmsEditScreenDataInterface>(
            `fdp/tms_edit_details/${GFC}/${Planning_period}`
          );
          resolve(data);
        }
      } catch (err) {
        return reject(err);
      }
    });
  },

  updateTMSData: (
    payload: {
      MarketShareID: number;
      TMSPlanningMonth: string;
      Adjustment: number;
      MarketSharePlan: number;
      Note: string;
      PlanningPeriod: string;
    }[]
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(`fdp/update_tms_details`, payload);
        resolve(data);
      } catch (error) {
        console.log('in services > updateMarketShareData, Err===', error);
        reject(error);
      }
    });
  },

  getConceptSalesPlan: (planning_period: string, GFC: number): Promise<salesPlanView> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<salesPlanView>(
          `fdp/get_sales_plan_details/${planning_period}/${GFC}`
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  getConceptSalesPlanEditData: (
    planning_period: string,
    gfc: number
  ): Promise<salesplanEditInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<salesplanEditInterface[]>(
          `fdp/get_sales_plan_edit_screen_data/${planning_period}/${gfc}`
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  updateSalesPlanData: (
    payload: {
      MarketShareAdjustment: number;
      Month: string;
      Adjustment: number;
      SalesPlan: number;
      Note: string;
      PlanningPeriod: string;
      MarketSalesForecast: string;
    }[]
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `fdp/salesplan-adjustments-save`,
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getActiveMarketForecastData: (
    cot: string,
    gfc: number
  ): Promise<activeMarketForecastInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<activeMarketForecastInterface[]>(
          `fdp/active_market_forecast/${cot}/${gfc}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  bulkUpdateMSplan: (payload: {
    gfc_list: number[];
    planning_period: string;
    user: string;
  }): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(`fdp/bulk_update_sales_plan`, payload);
        resolve(data);
      } catch (error) {
        console.log('tmsScreenService => bulkUpdateMSplan=> ', error);
        reject(error);
      }
    });
  },

  getFilteredDataForBulkEditSalesPlan: (
    payload: msPlanDataGetInterface,
    signal: AbortController['signal'] | null = null
  ): Promise<salesPlanBulkEditDataInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<salesPlanBulkEditDataInterface[]>(
            `fdp/get_sales_plan_bulk_edit_data`,
            payload
          );
          resolve(data);
        } else {
          const { data } = await postRequest<salesPlanBulkEditDataInterface[]>(
            `fdp/get_sales_plan_bulk_edit_data`,
            payload
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getFilteredDataForBulkEditSalesPlan, Err===', error);
        reject(error);
      }
    });
  },

  getFilteredDataForBulkEditMSPlan: (
    payload: msPlanDataGetInterface,
    signal: AbortController['signal'] | null = null
  ): Promise<msPlanBulkEditDataInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<msPlanBulkEditDataInterface[]>(
            `fdp/get_ms_plan_bulk_edit_data`,
            payload
          );
          resolve(data);
        } else {
          const { data } = await postRequest<msPlanBulkEditDataInterface[]>(
            `fdp/get_ms_plan_bulk_edit_data`,
            payload
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getFilteredDataForBulkEditSalesPlan, Err===', error);
        reject(error);
      }
    });
  },

  getGFCSuggestionsForMSPlan: (
    query: string,
    signal: AbortSignal | undefined = undefined
  ): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<string[]>(
            `fdp/get_ms_plan_gfc_suggestions`,
            { query },
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          await postRequest<string[]>(
            `fdp/get_ms_plan_gfc_suggestions`,
            { query },
            undefined,
            { signal }
          );
        }
      } catch (error) {
        console.log('in services > getGFCSuggestions, Err===', error);
        reject(error);
      }
    });
  },
  getGFCSuggestionsForSalesPlan: (
    query: string,
    signal: AbortSignal | undefined = undefined
  ): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<string[]>(
            `fdp/get_sales_plan_gfc_suggestions`,
            { query },
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          await postRequest<string[]>(
            `fdp/get_sales_plan_gfc_suggestions`,
            { query },
            undefined,
            { signal }
          );
        }
      } catch (error) {
        console.log('in services > getGFCSuggestions, Err===', error);
        reject(error);
      }
    });
  },

  updateNote: (id: number, note: string): Promise<updateNoteResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<updateNoteResponse>(`fdp/update_note`, {
          id: id,
          note: note,
        });
        resolve(data);
      } catch (error) {
        console.log('in service > updateNote, Err===', error);
        reject(error);
      }
    });
  },

  deleteNote: (id: number): Promise<boolean> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<boolean>(`fdp/delete_note`, {
          id: id,
        });
        resolve(data);
      } catch (error) {
        console.log('in service > updateNote, Err===', error);
        reject(error);
      }
    });
  },
};
